import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const [projectId, setProjectId] = useState(() => localStorage.getItem("ws_project_id") || null);
  const [project, setProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const [system, setSystem] = useState(null);

  const refreshProjects = useCallback(async () => {
    try {
      const list = await api.listProjects();
      setProjects(list);
      return list;
    } catch (e) { return []; }
  }, []);

  const selectProject = useCallback((id) => {
    setProjectId(id);
    if (id) localStorage.setItem("ws_project_id", id);
    else localStorage.removeItem("ws_project_id");
  }, []);

  const refreshProject = useCallback(async () => {
    if (!projectId) { setProject(null); return; }
    try { setProject(await api.getProject(projectId)); }
    catch (e) { setProject(null); selectProject(null); }
  }, [projectId, selectProject]);

  useEffect(() => { refreshProjects(); }, [refreshProjects]);
  useEffect(() => { refreshProject(); }, [refreshProject]);

  // system telemetry poll
  useEffect(() => {
    let alive = true;
    const tick = async () => { try { const s = await api.system(); if (alive) setSystem(s); } catch (e) {} };
    tick();
    const t = setInterval(tick, 5000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <AppCtx.Provider value={{ projectId, project, projects, system, selectProject, refreshProjects, refreshProject }}>
      {children}
    </AppCtx.Provider>
  );
}
